import {Suspense} from "react";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {AccountItems, AccountUserBase} from "@/lib/types/accounts.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {ContactGroupBaseItems} from "@/lib/types/contacts.ts";
import {EditUserForm} from "@/pages/accounts/edit/EditUserForm.tsx";
import {UserFormValues} from "@/pages/accounts/edit/EditUserFormBasic.tsx";

interface EditUserModalProps {
  formId: string;
  title: string;
  user?: AccountUserBase;
  accountAccounts: AccountItems;
  availableContactGroups: ContactGroupBaseItems;
  onSubmit: (data: UserFormValues) => Promise<void>;
  onCancel?: () => void;
  show: boolean;
  serverErrors?: ServerErrors;
  hide: () => void;
}

export const EditUserModal = ({
  formId,
  hide,
  user,
  accountAccounts,
  availableContactGroups,
  onSubmit,
  show,
  title,
  serverErrors,
}: EditUserModalProps) => (
  <Suspense>
    <UpErrorBoundary>
      <FormModal title={title} onCancel={hide} show={show} size="lg" formId={formId} hasRequiredFields>
        <EditUserForm
          user={user}
          accountAccounts={accountAccounts}
          availableContactGroups={availableContactGroups}
          formId={formId}
          onSubmit={onSubmit}
          onError={console.log}
          serverErrors={serverErrors}
        />
      </FormModal>
    </UpErrorBoundary>
  </Suspense>
);
